"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pageLoadConstants = {
    countryCode: 'us',
    language: 'en',
    siteDescriptor: 'iig',
    platform: 'web',
    is404: false,
    DLVersion: '1.0.0'
};
exports.default = pageLoadConstants;
